<template>
  <div class="portal-profile-settings">
    <div class="navigation">
      <router-link to="/portal/profile/usersettings">
        <VasionPersonIcon /> Profile Settings
      </router-link>
      <router-link to="/portal/profile/digitalSignature">
        <VasionGestureIcon /> Digital Signature
      </router-link>
      <router-link v-if="isPrivacyRouteVisible" to="/portal/profile/privacy">
        <VasionPrivacyShield /> Privacy
      </router-link>
    </div>
    <div class="content-container">
      <component :is="activeSettingsComponent" />
    </div>
  </div>
</template>

<script>
import ProfileSettings from '@/views/userSettings/ProfileSettings.vue'
import ProfileDigitalSignature from '@/views/userSettings/ProfileDigitalSignature.vue'
import ProfilePrivacy from '@/views/userSettings/ProfilePrivacy.vue'

export default {
  name: 'PortalProfileSettings',
  components: {
    ProfileSettings,
    ProfileDigitalSignature,
    ProfilePrivacy,
  },
  computed: {
    activeSettingsComponent() {
      const routeName = this.$route.name
      if (routeName === 'PortalProfileUserSettingsUsersettings') {
        return ProfileSettings
      } else if (routeName === 'PortalProfileUserSettingsDigitalSignature') {
        return ProfileDigitalSignature
      } else if (routeName === 'PortalProfileUserSettingsPrivacy') {
        return ProfilePrivacy
      }
      return null
    },
    isAdminUser() {
      return this.$store.getters['common/isAdminUser']
    },
    isPrivacyRouteVisible() {
      return this.isAdminUser
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/light-theme-system-palette.scss';
@import '@/assets/css/vuetify3Breakpoints.scss';

.portal-profile-settings {
  padding: 0;
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;
  gap: 16px;

  @include breakpoint-down('md') {
    flex-direction: column;
    padding: 0 12px;
  }

  .navigation {
    width: 194px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    @include breakpoint-down('md') {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      gap: 8px;
      margin-bottom: 16px;
      padding-top: 16px;
    }

    a {
      text-decoration: none;
      color: inherit;
      padding: 10px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 8px;
      text-decoration: none !important;
      transition: all 0.2s ease;
      border-radius: 4px;
      border: 1px solid transparent;

      @include breakpoint-down('md') {
        width: auto;
        padding: 8px 12px;
        font-size: 0.9rem;
        white-space: nowrap;
      }

      svg {
        font-size: 18px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;

        @include breakpoint-down('md') {
          width: 18px;
          height: 18px;
        }
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }

      &.router-link-active {
        color: $primary;
        font-weight: 500;
        background-color: rgba($primary, 0.12);
        border: 1px solid $primary;
        text-decoration: none !important;

        svg {
          fill: $primary;
        }
      }

      &.router-link-exact-active {
        color: $primary;
        font-weight: 600;
        text-decoration: none !important;
      }
    }
  }

  .content-container {
    flex: 1;
    overflow-y: auto;

    @include breakpoint-down('md') {
      padding: 0;
      width: 100%;
    }
  }
}
</style>
